import { render, staticRenderFns } from "./RemoveAccount.vue?vue&type=template&id=1ed901a1&scoped=true&lang=pug&"
import script from "./RemoveAccount.vue?vue&type=script&lang=ts&"
export * from "./RemoveAccount.vue?vue&type=script&lang=ts&"
import style0 from "./RemoveAccount.vue?vue&type=style&index=0&id=1ed901a1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed901a1",
  null
  
)

export default component.exports